export const FUNDING_VEHICLE_LIST_FETCH = 'FUNDING_VEHICLE_LIST_FETCH';
